<template>
  <div class="boxVip" >
    <div class="title">
      微信扫码,请选择vip时长(已办理过则时间叠加)(每种vip均可无限制下载) <span style="color:orange;"></span>
    </div>
    <div class="select" v-if="!erweimaShow">
      <div class="line" :style="{borderColor:(select==item.id?'orange':'#eee'),boxShadow:(select==item.id?'0px 0px 3px orange':'')}" @click="selectOption(item.id)" v-for="(item,key) in list">
        <sapn style="color:orange;font-size:30px;line-height:60px;position:relative;">{{item.name}}</sapn>
        <sapn style="color:#fff;">天数: <span style="color:#23e723;">{{item.day>36500?'永久':item.day}}</span> </sapn>
        <sapn style="color:#fff;">价格:￥ <span style="color:red;"> {{item.price}}</span></sapn>
        <img src="@/assets/vip1.png" alt="" style="width:60px;height:60px;position:absolute;top:20px;left:calc(50% - 30px)" v-if="key==0"/>
        <img src="@/assets/vip2.png" alt="" style="width:60px;height:60px;position:absolute;top:20px;left:calc(50% - 30px)" v-if="key==1"/>
        <img src="@/assets/vip3.png" alt="" style="width:60px;height:60px;position:absolute;top:20px;left:calc(50% - 30px)" v-if="key==2"/>
        <img src="@/assets/vip4.png" alt="" style="width:60px;height:60px;position:absolute;top:20px;left:calc(50% - 30px)" v-if="key==3"/>

      </div>
<!--      <div class="line" :style="{borderColor:(select==2?'orange':'#eee')}" :class="select==2" @click="selectOption(2)">-->
<!--        半年(49元)-->
<!--      </div>-->
<!--      <div class="line" :style="{borderColor:(select==3?'orange':'#eee')}" :class="select==3" @click="selectOption(3)">-->
<!--        永久(99元)-->
<!--      </div>-->
      <div style="width: 100%;">
        <el-button type="primary" @click="createOrderMy" style="margin-top: 15px;">
          微信支付
        </el-button>
        <el-button @click="close" type="primary">
          关闭
        </el-button>
      </div>

    </div>
    <div class="select" v-if="erweimaShow" style="display: flex;flex-direction: column;align-items: center;">
      <img :src="erweima" alt="">
      <el-button @click="close1" type="primary" style="margin-top: 15px;">
        我已付款(关闭)
      </el-button>
    </div>
  </div>
</template>
<script>
  import {createOrder,getVipList} from "@/api/qt/common"
  import QRCode from 'qrcode'
  import {Message} from "element-ui";
   export default {

      data(){
        return {
          select:1,
          erweima:"",
          erweimaShow:false,
          list:[]
        };
      },
     created() {
       this.getVip();
     },
     methods:{
        getVip(){
          getVipList().then(res => {
            this.list=res.data.data;
            console.log(this.list,'11');
          })
        },
       // setQRCode(str) {
       //   QRCode.toDataURL(str, { width: 192, margin: 1 }).then(res=>{
       //     // toDataURL方法返回一个promise
       //     this.erweima = res;
       //   })
       // },
        createOrderMy(){
         let loading=this.$loading({
           mask: true,
         })
          createOrder(this.select).then((res)=>{
            console.log(res.data,"创建订单返回")
            if(res.data.code==1){
              this.erweimaShow=true;
              let url=res.data.data;
              this.erweima=url;
            }else{
              Message(res.data.msg);
            }

            loading.close()
          })
        },
       close(){
         this.$emit("closeVip")
       },
       close1(){
         this.$emit("closeVip")
         window.location.href="http://"+window.location.host
       },
        selectOption(index){
          this.select = index;
        }
     }
   }
</script>
<style scoped>
.boxVip{
  width: 1200px;
  margin: 0 auto;
  border-radius: 13px;
  position: absolute;
  top:90px;
  left:calc(50% - 600px);
  box-sizing: border-box;
  z-index: 100000;
  box-shadow: 0px 0px 15px #000;
  background-color: rgba(3, 18, 49,0.8);
  //background-color: rgb(3, 18, 49);


}
.select{
  padding: 10px;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;

}
.title{
  text-align: center;
  line-height: 50px;
  color: #fff;
}
.line{
  width:20%;
  height:300px;
  text-align: center;

  border-radius: 19px;
  border: 1px solid #555;
  margin-top: 10px;
  box-sizing: border-box;
  cursor: pointer;
  margin-right: auto;
  margin-left: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;

  position: relative;
}
.line:hover{
  border: 1px solid orange;
  box-shadow: 0px 0px 5px #ccc;
}
</style>
